import React, { useState, useContext } from "react";
import { SessionContext } from "../../../../context/sessionContext";
import { WellsFargoBanner } from "./wellsFargoBanner";
import WellsFargoModal from "../modal/wellsFargoModal";
import i18n from "../../../../localization/i18n";
import * as rk from "../../../../localization/resourceKeys";
import "../modal/wellsFargoWrapper.scss";

export interface SpeedBumpState {
  title: string;
  text1: string;
  text2: string;
  externalLink: string;
}

export interface WellsFargoWrapperProps {
  // eslint-disable-next-line react/require-default-props
  modalClassName?: string;
}

export const WellsFargoWrapper: React.FC<WellsFargoWrapperProps> = ({
  modalClassName = "",
}) => {
  const { sessionDetails } = useContext(SessionContext);
  const enableAdobeAnalytics =
    process.env.REACT_APP_ADOBE_ANALYTICS_FLAG === "true";
  const wellsFargoLoginUrl = process.env.REACT_APP_WELLS_FARGO_LOGIN_URL;
  const wellsFargoFaqUrl = process.env.REACT_APP_WELLS_FARGO_FAQ_URL;
  const wellsFargoMessage =
    process.env.REACT_APP_WELLS_FARGO_BANNER === "true" &&
    sessionDetails?.brand === "VW" &&
    sessionDetails?.country === "USA";

  const [speedBumpState, setSpeedBumpState] = useState<SpeedBumpState | null>(
    null,
  );

  const handleContinue = () => {
    if (enableAdobeAnalytics) {
      const eventData = {
        event: "link_click",
        payload: {
          linkUrlClicked: speedBumpState.externalLink,
          source: "portal-auth",
          linkText: i18n.t(rk.BUTTON_CONTINUE),
        },
      };

      if (window.adobeDataLayer) {
        window.adobeDataLayer.push(eventData);
      }
    }
    window.open(speedBumpState.externalLink, "_blank");
    setSpeedBumpState(null);
  };

  const handleCancel = () => {
    if (enableAdobeAnalytics) {
      const eventData = {
        event: "link_click",
        payload: {
          linkUrlClicked: speedBumpState.externalLink,
          source: "portal-auth",
          linkText: i18n.t(rk.BUTTON_CANCEL),
        },
      };

      if (window.adobeDataLayer) {
        window.adobeDataLayer.push(eventData);
      }
    }
    setSpeedBumpState(null);
  };

  return (
    <div>
      {speedBumpState && (
        <WellsFargoModal
          title={i18n.t(rk.TITLE_MODAL)}
          subTitle1={i18n.t(rk.TEXT_MODAL1)}
          subTitle2={i18n.t(rk.TEXT_MODAL2)}
          continueText={i18n.t(rk.BUTTON_CONTINUE)}
          onContinue={handleContinue}
          cancelText={i18n.t(rk.BUTTON_CANCEL)}
          onCancel={handleCancel}
          modalClassName={modalClassName}
        />
      )}
      {wellsFargoMessage && (
        <WellsFargoBanner
          enableAdobeAnalytics={enableAdobeAnalytics}
          wellsFargoFaqUrl={wellsFargoFaqUrl}
          wellsFargoLoginUrl={wellsFargoLoginUrl}
          showSpeedBump={setSpeedBumpState}
        />
      )}
    </div>
  );
};
